import React from 'react';
import { KatRow, KatColumn } from '@amzn/katal-react';
import amazonLogo from 'src/images/amazon.png';
import './css/testPilot.css';

interface TestPilotHeaderProps {
    slot?: string;
}

const TestPilotHeader: React.FC<TestPilotHeaderProps> = ({ slot }) => {
    return (
        <header className="test-pilot-header" slot={slot}>
            <div className="header-container">
                <img
                    src={amazonLogo}
                    alt="Amazon Logo"
                    className="amazon-logo-icon"
                />
                <span className="test-pilot-title">TestPilot</span>
            </div>
        </header>
    );
};

export default TestPilotHeader;
